import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

import useSearchContext from "@hooks/useSearchContext";

type SearchResultProps = {
    imgUrl: string;
    slug: string;
    title: string;
    description: string;
    category: string;
    tags: string[];
    stock: number;
    isPreOrder: boolean;
    onClick?: () => void;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const { setQuery, close } = useSearchContext();

    const {
        onClick,
        imgUrl = "",
        slug = "",
        title = "",
        description = "",
        category = "",
        tags = [],
        stock = 0,
        isPreOrder = false,
    } = props;

    const [tagsToUse, setTagsToUse] = useState<string[]>([]);

    useEffect(() => {
        const tagsToUse = [];

        for (const t of tags) {
            const trimmed = t.trim();
            if (!trimmed || ["natural", "nature-powered", "nature powered"].includes(trimmed))
                continue;
            const trimmedCategory = category.trim();
            const wordifiedTag = trimmed.replace(/[^a-z0-9]+/g, "");
            const wordifiedCat = trimmedCategory.replace(/[^a-z0-9]+/g, "");
            if (!!trimmed && trimmed !== trimmedCategory && wordifiedTag !== wordifiedCat)
                tagsToUse.push(trimmed);
            if (tagsToUse.length >= 4) break;
        }

        setTagsToUse(tagsToUse);
    }, [tags, category]);

    if (!slug) return null;

    return (
        <div className="flex gap-4">
            <div className="relative">
                {imgUrl ? (
                    <img
                        src={imgUrl}
                        alt=""
                        className="h-20 w-20 rounded-xl object-cover ring-1 ring-black/5"
                    />
                ) : (
                    <div className="h-20 w-20 rounded-xl bg-neutral-200 dark:bg-neutral-700" />
                )}
                {stock === 0 && (
                    <div className="absolute top-1 left-1 bg-[#dc2626] text-white text-[10px] font-bold px-1.5 py-0.5 rounded">
                        Out of Stock
                    </div>
                )}
                {stock > 0 && stock < 10 && (
                    <div className="absolute top-1 left-1 bg-amber-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">
                        Low in Stock
                    </div>
                )}
                {stock > 10 && (
                    <div className="absolute top-1 left-1 bg-green-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">
                        in Stock
                    </div>
                )}
                {isPreOrder && (
                    <div className="absolute top-1 left-1 bg-indigo-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">
                        Pre-Order
                    </div>
                )}
            </div>
            <div className="min-w-0 flex-1">
                <Link
                    to={`/product/${slug}/`}
                    onClick={() => {
                        close();
                        onClick?.();
                    }}
                    className="line-clamp-1 font-medium text-emerald-700 hover:underline dark:text-emerald-300"
                >
                    {title}
                </Link>
                <p className="mt-1 line-clamp-2 text-sm text-neutral-600 dark:text-neutral-300">
                    {description || ""}
                </p>
                <div className="mt-2 flex flex-wrap gap-2 text-xs text-neutral-500 dark:text-neutral-400">
                    {category ? (
                        <button
                            onClick={() => setQuery(category)}
                            className="rounded-full bg-neutral-100 px-2 py-0.5 dark:bg-neutral-800"
                        >
                            {category}
                        </button>
                    ) : null}
                    {tagsToUse.map((t) => (
                        <button
                            key={t}
                            onClick={() => setQuery(t)}
                            className="rounded-full bg-neutral-100 px-2 py-0.5 dark:bg-neutral-800"
                        >
                            {t}
                        </button>
                    ))}
                    {/* <span className="ml-auto rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:ring-emerald-800">
                        {Math.round(__score)}
                    </span> */}
                </div>
            </div>
        </div>
    );
};

export default SearchResult;
